import request from 'graphql-request';
import { graphql } from '../../../gql/api-wr-tools/gql';
import type {
  BrainToolsHomeworkHelperFirstMutation,
  BrainToolsHomeworkHelperFirstMutationVariables,
} from '../../../gql/api-wr-tools/graphql';
import { IResponseData } from '../../../typings/common';
import { Endpoint } from '../../endpoint';

const mutation = graphql(/* GraphQL */ `
  mutation BrainToolsHomeworkHelperFirst(
    $clientHash: String!
    $clientUserId: String!
    $sessionSourceUrl: String!
    $gaCid: String!
    $requestType: String!
    $subject: String
    $instructions: String!
    $instructionsFromFiles: [String]
  ) {
    brainToolsHomeworkHelperFirst(
      clientHash: $clientHash
      clientUserId: $clientUserId
      sessionSourceUrl: $sessionSourceUrl
      gaCid: $gaCid
      requestType: $requestType
      subject: $subject
      instructions: $instructions
      instructionsFromFiles: $instructionsFromFiles
    ) {
      status {
        code
        message
      }
      generatedText
      responseGenIdHash
      chatIdHash
      textSubjectGroup
    }
  }
`);

interface IHomeworkHelpFirstResult {
  generatedText: string | null;
  responseGenIdHash: string | null;
  chatIdHash: string | null;
  textSubjectGroup: string | null;
}

export const generateFirstHomeworkHelp = async (
  payload: BrainToolsHomeworkHelperFirstMutationVariables
): Promise<IResponseData<IHomeworkHelpFirstResult>> => {
  const response = await request<
    BrainToolsHomeworkHelperFirstMutation,
    BrainToolsHomeworkHelperFirstMutationVariables
  >(Endpoint.GRAPHQL_WRITING_TOOLS_AI_CALL, mutation, payload);

  const {
    brainToolsHomeworkHelperFirst: {
      generatedText,
      responseGenIdHash,
      chatIdHash,
      status,
      textSubjectGroup,
    },
  } = response;

  const result: IHomeworkHelpFirstResult = {
    generatedText: generatedText ?? null,
    responseGenIdHash: responseGenIdHash ?? null,
    chatIdHash: chatIdHash ?? null,
    textSubjectGroup: textSubjectGroup ?? null,
  };

  return {
    data: result,
    status: status.code,
    message: status.message,
  };
};
